import { render, staticRenderFns } from "./PointActionModal.vue?vue&type=template&id=529469b2&scoped=true&"
import script from "./PointActionModal.vue?vue&type=script&lang=js&"
export * from "./PointActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529469b2",
  null
  
)

export default component.exports